import Calendar from 'react-calendar';
import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { LegacyButton } from '@/components/LegacyButton';
import { Modal as BaseModal } from '@/components/Modal';
import { NextImage } from '@/components/NextImage';
import { Row } from '@/components/Row';
import { Typography } from '@/components/Typography';
import { theme } from '@/theme';
import type { StockDisplay } from '@/views/WatchView/components/BookAppointmentModal/types';

interface StockDotProps {
  color: StockDisplay['color'];
}

export const CalendarStyled = styled(Calendar)`
  &.react-calendar {
    width: 400px;
    max-width: 100%;
    background: white;
    /* border: 1px solid #a0a096; */
    font-family:
      Open Sans,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Roboto,
      Oxygen-Sans,
      Ubuntu,
      Cantarell,
      Helvetica Neue,
      sans-serif !important;
    line-height: 1.125em;
  }

  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar__tile {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  .react-calendar__tile:hover,
  .react-calendar__tile:focus-visible {
    background: none !important;
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: -2px;
    z-index: 1;
  }
  .react-calendar__navigation__next2-button {
    display: none;
  }
  .react-calendar__navigation__prev2-button {
    display: none;
  }

  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }

  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }

  &.react-calendar,
  &.react-calendar *,
  &.react-calendar *:before,
  &.react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  &.react-calendar button {
    margin: 0;
    border: 0;
  }

  &.react-calendar button:enabled:hover {
    cursor: pointer;
  }

  // Add keyboard accessibility for calendar tiles
  &.react-calendar button:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: -2px;
    z-index: 1;
  }

  .react-calendar__navigation {
    display: flex;
    height: 38px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation__arrow:not(:disabled) {
    color: ${({ theme }) => theme.colors.primary};
  }
  .react-calendar__navigation button {
    background: none;
  }

  .react-calendar__navigation button:disabled {
    background-color: none;
  }
  .react-calendar__navigation__label {
    overflow: hidden;
    pointer-events: none;
    font-weight: bold;
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:focus-visible {
    background-color: transparent;
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: 2px;
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font: inherit;
    font-size: 0.75em;
    font-weight: bold;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekdays__weekday abbr {
    font-size: 14px;
    text-decoration: none;
  }

  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font: inherit;
    font-size: 0.75em;
    font-weight: bold;
  }

  .react-calendar__month-view__days__day--weekend {
    /* color: #d10000; */
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }

  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: 16px;
    font: inherit;
    font-size: 0.833em;
    border-bottom: 1px solid #e1e1e1 !important;
  }

  .react-calendar__tile:disabled {
    background-color: #fafafa;
  }
  .react-calendar__navigation__prev-button {
    margin-left: 95px !important;
    @media (max-width: 480px) {
      margin-left: 60px !important;
    }
  }
  .react-calendar__navigation__prev-button:disabled {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  .react-calendar__navigation__prev-button:hover {
    background-color: transparent !important;
  }
  .react-calendar__navigation__next-button {
    font-size: 14px !important;
    margin-right: 95px !important;
    @media (max-width: 480px) {
      margin-right: 60px !important;
    }
  }
  .react-calendar__navigation__next-button:disabled {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  .react-calendar__navigation__next-button:hover {
    background-color: transparent !important;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus-visible {
    background-color: #e6e6e6;
    outline: 2px solid ${({ theme }) => theme.colors.black};
    outline-offset: -2px;
  }

  .react-calendar__tile--now {
    background: ${({ theme }) => theme.colors.primary};
  }

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus-visible {
    background: ${({ theme }) => theme.colors.primary};
    outline: 2px solid ${({ theme }) => theme.colors.black};
    outline-offset: -2px;
  }

  .react-calendar__tile--active {
    background: ${({ theme }) => theme.colors.primary};
    // color: white;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus-visible {
    background: ${({ theme }) => theme.colors.primary} !important;
    outline: 2px solid ${({ theme }) => theme.colors.black} !important;
    outline-offset: -2px;
  }

  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }
`;
export const Title = styled(Typography)`
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h4};
    margin: ${theme.spacing(1)};
  `}
`;

export const Body = styled(Box)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    margin: 0 ${theme.spacing(1)};
    scale: ${theme.fontSizes.p0};
    color: ${theme.colors.defaultAdd3};
    line-height: ${theme.lineHeights.p0};
  `}
`;

export const ButtonCTA = styled(Box)`
  margin: 0 auto;
  // width:95%;
  ${theme.media.md.up} {
    width: 373px;
  }
`;
export const ProductBannerWrapper = styled(Box)`
  ${({ theme }) => css`
    display:flex;
    justify-content:center;
    align-items: center;
    padding-top: ${theme.spacing(2)};
    padding-bottom: ${theme.spacing(2)};
    background-color: ${theme.colors.disableGrey};
    ${theme.media.md.up} {
      justify-content: center;
    }
}


`};
`;

export const Dot = styled.span<StockDotProps>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => {
    switch (props.color) {
      case 'success':
        return theme.colors.successLight;
      case 'warning':
        return theme.colors.primaryLight;
      case 'error':
        return theme.colors.errorLight;
      default:
        return theme.colors.errorLight;
    }
  }};
`;

export const BoutiqueCardWrapper = styled(Box)`
  position: relative;
  padding: 32px 28px;
`;
export const TextButton = styled.span`
  display: block;
  text-align: center;
  white-space: normal;
  overflow-wrap: break-word;
`;
export const ContactFlex = styled(Flex)`
  margin-top: 14px;
  margin-bottom: 25px;
  flex-wrap: wrap;
`;
export const StyledIcon = styled(Icon)`
  display: inline-block;
  vertical-align: middle;
`;

export const BannerImageBox = styled(Box)`
  height: 144px;
`;
export const ProductImage = styled(NextImage)`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
export const ProductHeaderDesc = styled(Box)`
  max-width: 50%;
`;
export const StoreImage = styled(NextImage)`
  height: auto;
  width: 100%;
  aspect-ratio: 3.2;
  object-fit: cover;
  ${theme.media.sm.down} {
    aspect-ratio: 2;
  }
`;
export const DiscoverButton = styled(LegacyButton)`
  width: 90%;
  margin-top: 32px;
  margin-bottom: 40px;
  ${theme.media.md.up} {
    max-width: 373px;
  }
`;
export const AppointmentButton = styled(LegacyButton)`
  width: 90%;
  margin-bottom: 19px;
  ${theme.media.md.up} {
    max-width: 373px;
  }
`;

export const FlexButtonBox = styled(Box)`
  display: flex;
  justify-content: center;
`;
export const SameDayAppointmentWrapper = styled(Box)`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 100%;
`;
export const SameDayAppointmentBox = styled(Box)`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 400px;
`;
export const TimeSlotWrapper = styled(Box)`
  padding: 0 auto;
`;
export const ChangeStoreButtonBox = styled(Box)`
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const CalendarWrapper = styled(Box)`
  margin: 0 auto;
  display: flex;
  justify-content: center;

  overflow: visible;

  .react-calendar {
    color: black;
  }
  .react-calendar__navigation__label {
    color: black;
  }
  .react-calendar__tile {
    color: black;
  }
  .react-calendar__navigation {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .react-calendar__navigation button {
    min-width: fit-content;
  }
`;
export const CommentsWrapper = styled(Box)`
  margin: 0 auto;
`;
export const RegionCol = styled(Col)`
  margin: 0 auto;
  margin-top: 30px;
`;
export const ReasonCol = styled(Col)`
  margin: 0 auto;
  margin-top: 32px;
  max-width: 400px;
`;
export const TextAreaCol = styled(Col)`
  margin: 0 auto;
  margin-top: 24px;
`;
export const TimeSlotCol = styled(Col)`
  margin: 0 auto;
  max-width: 400px;
`;
export const RecaptchaCol = styled(Col)`
  margin-top: 16px;
  margin-bottom: 32px;
`;
export const LegalCheckBoxCol = styled(Col)`
  margin-top: 36px;
  padding-left: 16px;
  padding-right: 16px;
`;
export const FirstNameFieldCol = styled(Col)`
  margin: 0 auto;
  max-width: 400px;
  margin-top: 16px;
`;
export const LastNameFieldCol = styled(Col)`
  margin: 0 auto;
  max-width: 400px;
  margin-top: 30px;
`;
export const EmailFieldCol = styled(Col)`
  margin: 0 auto;
  max-width: 400px;
  margin-top: 30px;
`;
export const PhoneFieldCol = styled(Col)`
  margin: 0 auto;
  max-width: 400px;
  margin-top: 30px;
`;

export const PersonalInfoBox = styled(Box)`
  margin: 0 auto;
`;
export const NamesBox = styled(Row)`
  margin: ${theme.spacing(2)} auto 0;

  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: 416px;
    }
  `}
`;
export const TitleFlex = styled(Row)`
  margin: 0 auto;
  max-width: 416px;
`;
export const StoreImageBox = styled(Box)`
  padding: 0 20px;
`;

export const CenteredSpan = styled.span`
  display: inline-block;
  vertical-align: middle;
`;
export const HeroWrapper = styled(Box)`
  text-align: left;
  ${({ theme }) => css`
    color: ${theme.colors.default};
  `}
  position: relative;
`;
export const HeroText = styled(Box)`
  left: 50%;
  position: absolute;
  text-align: center;
  top: 50%;
  z-index: ${theme.zIndex.baseCmsCard};
  transform: translate(-50%, -50%);
  width: 100%;
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const HeroHeading = styled(Typography)`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacing(2)};
  `}
`;
export const StoreImageWrapper = styled(Box)``;
export const StyledLink = styled.a`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    color: ${theme.colors.primaryBlue};
    text-decoration: none;
  `}
`;

export const continueBrowsingDivider = styled.hr`
  background: #ebebeb;
  border: 0;
  height: 0.1px;
  margin: 18px 0 33px 0;
  margin-left: -5%;
  width: 109%;
`;

export const breitlingIcon = styled(Icon)`
  display: block;
`;
export const OptinOptionsText = styled(Box)`
  & > a {
    font-weight: ${theme.fontWeights.semibold};
    color: ${theme.colors.primaryDark};
  }
`;

export const LegalTextWrapper = styled(Box)`
  font-weight: ${theme.fontWeights.regular};
  font-family: ${theme.fontFamilies.openSans};
`;

export const Modal = styled(BaseModal)`
  && {
    padding-block: ${theme.spacing(0, 3)};
  }
`;
export const ModalHeaderWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  position: relative;
  position: sticky;
  top: 0;
  z-index: ${theme.zIndex.alwaysVisible};
`;
export const ModalHeader = styled(Box)`
  padding-top: ${theme.spacing(3)};
  padding-bottom: ${theme.spacing(2)};
  width: 100%;
  background: white;
`;

export const StoreLocatorButton = styled(Box)`
  a {
    text-decoration: none;
  }
`;

export const ImageCover = styled(Box)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colors.primaryDark};
`;
